export const catalogDefaultFilters = [
  { label: "Price", propName: "price" },
  { label: "Product Type", propName: "productType" },
  { label: "Quantity", propName: "quantity" },
  { label: "Created by", propName: "creator" },
  { label: "Media Type", propName: "media_type" },
  { label: "Media", propName: "isThereMedia" },
  { label: "Share link access", propName: "isPrivate" },
];
